import {
  ComboboxData,
  NativeSelect,
  NativeSelectProps
} from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { JccCampus } from "../types/request.types";
import { mtsUrl } from "../lib/mts-url";

export default function CampusSelect(props: NativeSelectProps) {
  const campusesQuery = useQuery({
    queryKey: ['campuses'],
    queryFn: () => axios.get(mtsUrl('campuses'))
  });
  let campuses: ComboboxData;

  if (campusesQuery.isSuccess) {
    campuses = [{value: '', label: ''}].concat(
      campusesQuery.data.data.map((c: JccCampus) => ({
        value: c.id,
        label: c.name
      }))
    );
  } else {
    campuses = [];
  }
  
  return (
    <NativeSelect
      {...props}
      data={campuses}
    />
  );
}
